<div class="container">
    <div class="header">
        <smart-icon name="arrow-left" class="back-icon light" (click)="onBtnCancel()"></smart-icon>
        <div class="title" title="{{quickTaskTitle}}">
            {{quickTaskTitle}}
        </div>
        <div class="close">
            <smart-icon name="close" class="dialog-close light" (click)="onBtnClose()"></smart-icon>
        </div>
    </div>
    <div class="form">
        <form [formGroup]="taskFormGroup" class="task-form">
            <div class="tam-form-field" [ngClass]="{'has-error': subject.invalid}">
                <div class="tam-form-label form-subject">
                    <span class="form-label">Subject&nbsp;<span class="required-field">*</span></span>
                </div>
                <input type="text" class="tam-textbox" formControlName="subject" [readonly]='controlReadonly'
                    tid="task_subject_input">
                <div class="tam-form-help" *ngIf="subject.invalid && subject.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help" *ngIf="subject.invalid && subject.errors['maxlength']">
                    Subject exceeds the maximum of 128 characters allowed.
                </div>
            </div>
            <div class="tam-form-field form-details" [ngClass]="{'has-error': details.invalid}">
                <div class="tam-form-label">
                    <span class="form-label">Details</span>
                </div>
                <textarea class="tam-textbox details-info" formControlName="details" [readonly]='controlReadonly'
                    tid="task_detail_input"></textarea>
                <div class="tam-form-help" *ngIf="details.invalid && details.errors['maxlength']">
                    Details exceeds the maximum of 2048 characters allowed.
                </div>
            </div>
            <div class="due-date-remind-date-priority">
                <div class="tam-form-field form-due-date">
                    <div class="tam-form-label">
                        <span class="form-label">Due Date</span>
                    </div>
                    <div class="due-date">
                        <kendo-datepicker calendarType="classic" #duedatepicker formControlName="dueDate"
                            [(value)]="dueDateData" [rangeValidation]="false" [min]="min" [max]="max"
                            [disabledDates]="disabledDueDates" (blur)="onDueDateBlur()" [readonly]="controlReadonly">
                        </kendo-datepicker>
                    </div>
                </div>
                <div class="tam-form-field form-remind-date">
                    <div class="tam-form-label">
                        <span class="form-label">Reminder</span>
                    </div>
                    <div class="remind-date">
                        <div class="remind-date-date">
                            <kendo-datepicker calendarType="classic" #datepicker formControlName="remindDate"
                                [(value)]="remindDateDateData" [rangeValidation]="false" [min]="min" [max]="max"
                                [disabledDates]="disabledRemindDates" (blur)="onRemindDateDateBlur()"
                                (valueChange)="onRemindDateDateChange($event)" [readonly]="reminderReadonly">
                            </kendo-datepicker>
                        </div>
                        <div class="remind-date-time">
                            <time-select-dropdown (clickss)="onRemindDateTimeClick($event)"
                                (timeBlur)="onRemindDateTimeBlur($event)" [(myModel)]="remindDateTimeData"
                                (timeModelChange)="onRemindDateTimeChange($event)" [readonly]="remindDateTimeNotValid">
                            </time-select-dropdown>
                        </div>
                    </div>
                </div>
                <div class="tam-form-field form-priority">
                    <div class="tam-form-label">
                        <span class="form-label">Priority</span>
                    </div>
                    <kendo-dropdownlist formControlName="priority" [filterable]="false" [data]="prioritySource"
                        class="priority-info" [readonly]="controlReadonly">
                    </kendo-dropdownlist>
                </div>
            </div>
            <div class="tam-form-field form-assignee" [ngClass]="{'has-error': assignee.invalid}" tid="add_assignee">
                <div class="tam-form-label">
                    <span class="form-label">Assign To&nbsp;<span class="required-field">*</span></span>
                </div>
                <kendo-multiselect #assigneelist formControlName="assignee" class="assignee-type-list"
                    [data]="assigneeDataItems" [filterable]="true" (open)="onOpenAssignee($event)"
                    (filterChange)="assigneeFilter($event)" [autoClose]="true" [textField]="'name'" [valueField]="'id'"
                    (valueChange)="valueChangeForAssignee($event)" [readonly]="controlReadonly">

                    <ng-template kendoMultiSelectNoDataTemplate>
                        <div class="popup-template-no-data">
                            <div class="no-data"><span>NO DATA FOUND</span></div>
                        </div>
                    </ng-template>
                </kendo-multiselect>
                <div class="tam-form-help" *ngIf="assignee.invalid && assignee.errors['required']">
                    <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
                </div>
            </div>
            <div class="tam-form-field form-finish-flag">
                <div class="finish-flag">
                    <label formControlName="finishFlag" tam-checkbox [isDisabled]="finishFlag.disabled"
                        (click)="onCheckedChange()"></label>
                    <div class="finish-content">
                        <span class="tam-form-label">Task will be closed when&nbsp;</span>
                        <kendo-dropdownlist class="finish-number" [data]="finishNumberSource"
                            formControlName="finishNumber" [filterable]="true">
                        </kendo-dropdownlist>
                        <span class="tam-form-label">&nbsp;assignees complete</span>
                    </div>
                </div>
            </div>
            <div class="tam-form-field form-related">
                <div class="tam-form-label">
                    <span class="form-label">Related To&nbsp;</span>
                </div>
                <kendo-multiselect #entitylist formControlName="related" class="related-type-list"
                    [data]="relatedDataItems" [filterable]="true" (open)="onOpenRelated($event)"
                    (filterChange)="relatedFilter($event)" [autoClose]="true" [textField]="'shortName'"
                    [valueField]="'id'" (keydown.esc)="onEnter($event)" (mousedown)="$event.preventDefault()"
                    [readonly]="controlReadonly">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                    </ng-template>
                    <ng-template kendoMultiSelectNoDataTemplate>
                        <div class="popup-template-no-data">
                            <div class="no-data"><span>NO DATA FOUND</span></div>
                        </div>
                    </ng-template>
                </kendo-multiselect>
                <div class="tam-form-help" *ngIf="related.invalid && related.errors['required']">
                    <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
                </div>
            </div>
        </form>
    </div>
    <div class="footer" *ngIf="!hideFooter">
        <div class="operation-box">
            <button class="footer-button" tam-button (click)="onBtnCancel()" [tamType]="'tertiary'"
                [tamSize]="'normal'">Cancel</button>
            <button class="footer-button" tam-button (click)="onBtnSave()"
                [tamType]="showMarkAsDoneBtn?'secondary':'primary'" [tamSize]="'normal'" [tamLoading]="isProgressing"
                [disabled]="isProgressing">Save</button>
            <button class="footer-button" tam-button (click)="onBtnMarkAsDone()" [tamType]="'primary'"
                [tamSize]="'normal'" [ngClass]="showMarkAsDoneBtn?'':'hiddenButton'">Mark as
                Done</button>
        </div>
    </div>
</div>